import React from 'react';
import { Link } from 'react-router-dom';

import './Header.scss';
import logo from '../../logo.png';

const Header = () => {

    const [ ipAdd, setIpAdd ] = React.useState( '0.0.0.0' );

    React.useEffect( () => {

        fetch( 'https://api.my-ip.io/ip', {headers: {"Content-Type": "text/plain"}} )
        .then( ( resp ) => resp.text() )
        .then( ( data ) => setIpAdd( data ) )
        .catch( (e) => console.log( 'IP API service is currently offline' ) );
    
    },[]);

    return (
        <header>
            <section className="site__info">
                <div className="site__logo">
                    <img src={logo} style={{width: '53px'}} alt="logo" />
                </div>
                <div className="site__title">Kalihackz</div>
            </section>
            <section className="site__navbar">
                <nav className="navbar">
                    <Link to="/" className="navbar__item">
                        <div>Home</div>
                    </Link>
                    <Link to="/apis" className="navbar__item">
                        <div>API</div>
                    </Link>
                    <Link to="/projects" className="navbar__item">
                        <div>Projects</div>
                    </Link>
                    <Link to="/blogs" className="navbar__item">
                        <div>Blogs</div>
                    </Link>
                </nav>
            </section>
            <section className="site__stats">
                <div id="ipadd">
                    IP : {ipAdd}
                </div>
            </section>
        </header>
    );

}

export default Header;